import "idempotent-babel-polyfill";
import { renderWidgetReactComponent } from "./components/Widget";

export class Mcw {
  maxConfig: any = null;
  private hasRendered: boolean = false;

  constructor() {}

  public init = (config: any): void => {
    this.maxConfig = config;
    if (document.readyState === "loading") {
      document.addEventListener(
        "DOMContentLoaded",
        this.handleDOMContentLoaded
      );
    } else {
      this.handleDOMContentLoaded();
    }
  };

  private handleDOMContentLoaded = (): void => {
    const container = document.body;
    this.appendWidget(container);
  };

  public appendWidget = (container: HTMLElement): void => {
    // Inject CSS Styles
    const style = document.createElement("style");
    style.type = "text/css";
    style.innerHTML = `
      #maximise-pulse-wrapper .pulse_launcher {
        border: none;
        position: fixed;
        bottom: 20px;
        ${this.maxConfig?.default_chatbot_position === "bottom-left" ? "left: 20px;" : "right: 20px;"}
        width: 48px;
        height: 48px;
        z-index: 9999;
        border-radius: 25px;
        transform-origin: center center;
        transition: transform 250ms cubic-bezier(0.33, 0, 0, 1);
      }
      #maximise-pulse-wrapper .pulse_launcher:hover {
        transform: scale(1.1);
      }
      #maximise-pulse-wrapper .pulse_frame {
        z-index: 2147483000;
        position: fixed;
        bottom: 84px;
        ${this.maxConfig?.default_chatbot_position === "bottom-left" ? "left: 20px;" : "right: 20px;"}
        ${this.maxConfig?.default_chatbot_position ? "transform-origin: left bottom;" : "transform-origin: right bottom;"}
        height: min(704px, 100% - 104px);
        min-height: 80px;
        width: 400px;
        max-height: 704px;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: rgba(0, 0, 0, 0.16) 0px 5px 40px;
        opacity: 0;
        transform: scale(0);
        transition: width 200ms, height 200ms, max-height 200ms, transform 300ms cubic-bezier(0, 1.2, 1, 1), opacity 200ms ease-out;
        pointer-events: none;
      }

      @media (max-width: 768px){
        #maximise-pulse-wrapper .pulse_frame {
            transform-origin: right bottom;
            min-height: 80px;
            overflow: hidden;
            box-shadow: rgba(0, 0, 0, 0.16) 0px 5px 40px;
            opacity: 1;
            z-index: 2147483001;
            width: 100%;
            max-height: none;
            inset: 0px;
            border-radius: 0px;
            position: fixed;
            height: 100%;
            transition: width 200ms, height 200ms, max-height 200ms, transform 300ms cubic-bezier(0, 1.2, 1, 1), opacity 83ms ease-out;
            pointer-events: all;
        }
      }
      #maximise-pulse-wrapper .pulse_frame.open {
        opacity: 1;
        transform: scale(1);
        pointer-events: all;
      }

       #maximise-pulse-wrapper .pulse_frame.expand {
        width: 90vw;
      }
      #maximise-pulse-wrapper .pulse_frame.incoming_call {
        width: 50vw;
      }

      #maximise-pulse-wrapper .pulse_alert {
        z-index: 2147483000;
        position: fixed;
        width: 400px;
        color-scheme: none;
        ${this.maxConfig?.default_chatbot_position === "bottom-left" ? "left: 20px;" : "right: 20px;"}
        bottom: 74px;
        max-height: calc(100% - 40vh);
        height: auto;
      }

      @media (max-width: 768px){
        #maximise-pulse-wrapper .pulse_frame.incoming_call {
          width: 100vw;
        }
        #maximise-pulse-wrapper .pulse_frame.expand {
          width: 100vw;
        }
        #maximise-pulse-wrapper .pulse_alert {
            user-select: none;
            z-index: 2147483000;
            position: fixed;
            bottom: 5rem;
            ${this.maxConfig?.default_chatbot_position === "bottom-left" ? "left: 2%;" : "right: 2%;"}
            width: 100%;
            transition: transform 167ms cubic-bezier(0.33, 0, 0, 1);
            transform-origin: center center;
        }
      }
      #maximise-pulse-wrapper .pulse_alert.open {
        transform: scale(1);
        pointer-events: all;
      }

      #maximise-pulse-wrapper .pulse_call_alert {
        z-index: 2147483000;
        position: fixed;
        width: 400px;
        color-scheme: none;
        ${this.maxConfig?.default_chatbot_position === "bottom-left" ? "left: 20px;" : "right: 20px;"}
        bottom: 74px;
        max-height: calc(100% - 10vh);
        height: 100%;
      }

      @media (max-width: 768px){
        #maximise-pulse-wrapper .pulse_call_alert {
            user-select: none;
            z-index: 2147483000;
            position: fixed;
            bottom: 5rem;
            ${this.maxConfig?.default_chatbot_position === "bottom-left" ? "left: 2%;" : "right: 2%;"}
            width: 100%;
            transition: transform 167ms cubic-bezier(0.33, 0, 0, 1);
            transform-origin: center center;
        }
      }
      #maximise-pulse-wrapper .pulse_call_alert.open {
        transform: scale(1);
        pointer-events: all;
      }
    `;
    document.head.appendChild(style);

    const attemptRender = () => {
      if (this.hasRendered) return;

      if (window.localStorage) {
        //@ts-ignore
        const metaDescription = document
          ?.querySelector("meta[name='description']")
          ?.getAttribute("content");
        const mx_uid = window.localStorage.getItem("mx_uid");
        const mx_cid = window.localStorage.getItem("mx_cid");
        const mx_lim = window.localStorage.getItem("mx_lim");
        const mx_lis = window.localStorage.getItem("mx_lis");
        const mx_tdm = window.localStorage.getItem("mx_tdm");
        const up_id = window.localStorage.getItem("up_id");
        const referrer = window.localStorage.getItem("mx_referrer");
        const mx_session_id = window.localStorage.getItem("mx_session_id");
        const mx_last_activity =
          window.localStorage.getItem("mx_last_activity");
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (mx_uid) {
          this.maxConfig = {
            ...this.maxConfig,
            mx_uid: mx_uid,
            mx_cid,
            mx_lim,
            mx_lis,
            mx_tdm,
            up_id,
            referrer,
            mx_session_id,
            mx_last_activity,
            time_zone: timeZone,
            current_page: {
              title: document?.title,
              description: metaDescription,
              url: window.location.href,
            },
          };
          renderWidgetReactComponent(container, this.maxConfig);
          this.hasRendered = true;
        }
      }
    };

    // Initial attempt to render
    attemptRender();

    if (!this.hasRendered) {
      // Listener for storage events (changes from other tabs/windows)
      const onStorageChange = (event: StorageEvent) => {
        if (event.key === "mx_uid" && event.newValue) {
          attemptRender();
          window.removeEventListener("storage", onStorageChange);
        }
      };

      window.addEventListener("storage", onStorageChange);

      // Optional: Listen for custom events within the same window
      const onCustomEvent = () => {
        attemptRender();
        window.removeEventListener("mx_uid_changed", onCustomEvent);
      };

      window.addEventListener("mx_uid_changed", onCustomEvent);

      // Optional: Implement polling as a fallback
      const maxAttempts = 10;
      let attempts = 0;
      const interval = setInterval(() => {
        if (this.hasRendered) {
          clearInterval(interval);
          return;
        }
        //@ts-ignore
        const metaDescription = document
          ?.querySelector("meta[name='description']")
          ?.getAttribute("content");
        const mx_uid = window.localStorage.getItem("mx_uid");
        const mx_cid = window.localStorage.getItem("mx_cid");
        const mx_lim = window.localStorage.getItem("mx_lim");
        const mx_lis = window.localStorage.getItem("mx_lis");
        const mx_tdm = window.localStorage.getItem("mx_tdm");
        const up_id = window.localStorage.getItem("up_id");
        const referrer = window.localStorage.getItem("mx_referrer");
        const mx_session_id = window.localStorage.getItem("mx_session_id");
        const mx_last_activity =
          window.localStorage.getItem("mx_last_activity");
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        if (mx_uid || this.maxConfig?.test) {
          this.maxConfig = {
            ...this.maxConfig,
            mx_uid: mx_uid,
            mx_cid,
            mx_tdm,
            mx_lis,
            mx_lim,
            up_id,
            referrer,
            mx_session_id,
            mx_last_activity,
            time_zone: timeZone,
            current_page: {
              title: document?.title,
              description: metaDescription,
              url: window.location.href,
            },
          };
          console.log("config", this.maxConfig);
          renderWidgetReactComponent(container, this.maxConfig);
          this.hasRendered = true;
          clearInterval(interval);
        } else if (attempts >= maxAttempts) {
          clearInterval(interval);
        }
        attempts++;
      }, 1000);
    }
  };
}

if (typeof window !== "undefined") {
  const mcwInstance = new Mcw();
  // @ts-ignore
  window.Mcw = mcwInstance;
}
